var App = App || {};

App.Accordion = (function () {
    "use strict";
    var distance = "";

    function init() {
        $('button.collapsed:not(.solutions-finder-button)').on("click", function (e) {
            distance = $(e.currentTarget.getAttribute('data-bs-target')).position().top - 100;

            setTimeout(
                function () {
                    distance;
                }, 500);

            setTimeout(
                function () {
                    $('html, body').animate({
                        scrollTop: $(e.currentTarget.getAttribute('data-bs-target')).offset().top
                    }, 500);
                }, 700);

        });

    }

    return {
        init: init
    };
})();

$(function () {
    App.Accordion.init();
});